import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally, reveals a success message after copying.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  #hideTimer;

  disconnectedCallback() {
    super.disconnectedCallback();
    clearTimeout(this.#hideTimer);
  }

  copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');

    if (!copyContent) return;

    navigator.clipboard.writeText(copyContent);

    const copySuccessMessage = this.refs.copySuccessMessage;

    if (!(copySuccessMessage instanceof Element)) return;

    if (copySuccessMessage.classList.contains('product-share__toast')) {
      copySuccessMessage.classList.add('product-share__toast--visible');
      copySuccessMessage.setAttribute('aria-hidden', 'false');
      clearTimeout(this.#hideTimer);
      this.#hideTimer = setTimeout(() => {
        copySuccessMessage.classList.remove('product-share__toast--visible');
        copySuccessMessage.setAttribute('aria-hidden', 'true');
      }, 2200);
      return;
    }

    copySuccessMessage.classList.remove('visually-hidden');
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
